//Include Both Helper File with needed methods
import { postProfileUpdate } from "../../../helpers/backend_helper";

// action
import { profileSuccess, profileError, resetProfileFlagChange } from "./reducer";

export const editProfile = (user : any) => async (dispatch : any) => {
    try {
        const response = await postProfileUpdate(user);
        const payload = response?.data ?? response;

        if (payload) {
            const normalized = {
                success: payload.success ?? true,
                data: payload.data?.user ?? payload.data ?? payload.user ?? {},
                message: payload.message,
            };

            dispatch(profileSuccess(normalized));
        }

    } catch (error) {
        dispatch(profileError(error));
    }
};

export const resetProfileFlag = () => {
    try {
        const response = resetProfileFlagChange();
        return response;
    } catch (error) {
        return error;
    }
};
